import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-alert-delete-user',
  templateUrl: './alert-delete-user.component.html',
  styleUrls: ['./alert-delete-user.component.scss'],
})
export class AlertDeleteUserComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
